module.exports = __webpack_public_path__ + "account/img/40.dba632cf.png";